import React, { useMemo } from 'react';
import LinkCandidateProfile from '../../../../../../components/LinkCandidateProfile';
import {DateHelpers} from '../../../../../../helpers/date-helpers';
import FeedPostContentFirmLink from '../FeedPostContentFirmLink';

const TypeCandidatePositionApproved = props => {
  const {
    user,
    post: {
      CandidateID,
      FullName,
      FirmName,
      FirmUrlAlias,
      FirmActive,
      currentSchoolName,
      TitleName,
      NewsFeedDateAdd,
      Date,
      ViewProfile,
      ViewAsRecruiter,
    },
  } = props;

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        <LinkCandidateProfile
          cls="feed-post-content__hero"
          clsSpan="feed-post-content__hero"
          styleSpan={{ marginRight: '0.5em' }}
          user={user}
          id={CandidateID}
          name={FullName}
          viewProfile={ViewProfile === 'Yes'}
          viewAsRecruiter={ViewAsRecruiter === 'Yes'}
        />
        <div className="feed-post-content__text">{`has a new position of ${TitleName} in`}</div>
        <FeedPostContentFirmLink
          isActive={FirmActive === 'Yes'}
          alias={FirmUrlAlias}
          firm={FirmName}
          school={currentSchoolName}
        />
      </div>
      <div className="feed-post-content__date">{date}</div>
    </div>
  );
};

export default TypeCandidatePositionApproved;
